// extracted by mini-css-extract-plugin
export default {"layout":"default_layout__gwQRw","header":"default_header__Lo+9Y","headerBg":"default_headerBg__7RK6O","scan":"default_scan__hfy96"};